import { APP_PERMISSIONS } from '@exam-management/permissions';

export const ADD_LOS_REQUIRED_PERMISSIONS = [
  APP_PERMISSIONS.QBANK.LOS.VIEW,
  APP_PERMISSIONS.QBANK.LOS.CREATE,
];

export const EDIT_LOS_REQUIRED_PERMISSIONS = [
  APP_PERMISSIONS.QBANK.LOS.VIEW,
  APP_PERMISSIONS.QBANK.LOS.UPDATE,
];

export const DELETE_LOS_REQUIRED_PERMISSIONS = [
  APP_PERMISSIONS.QBANK.LOS.VIEW,
  APP_PERMISSIONS.QBANK.LOS.DELETE,
];

export const FALLBACK_LEVEL_NAME = 'ไม่ระบุ';

export const LOS_ALLOWED_CHARACTERS_REGEX = /^[ก-๏a-zA-Z0-9\s,\-_".()/:]*$/;

export const LOS_MAX_LENGTH = 1024;

export const LOS_ALLOWED_CHARACTERS_MESSAGE =
  'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _  , “” () / : เท่านั้น';

export const LOS_REQUIRED_MESSAGE = 'กรุณากรอกวัตถุประสงค์การเรียนรู้';

export const LOS_DUPLICATE_MESSAGE =
  'มีการเพิ่มวัตถุประสงค์การเรียนรู้ซ้ำ กรุณาเพิ่มวัตถุประสงค์การเรียนรู้อื่น';
